// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-container[data-v-041676ff] {\n  max-height: 588px;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #fff;\n}\n.highcharts-root[data-v-041676ff] {\n  padding: 0px;\n}\n.make-bold[data-v-041676ff] {\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
